/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookmarkedPressReleasesResponseAllOf,
    BookmarkedPressReleasesResponseAllOfFromJSON,
    BookmarkedPressReleasesResponseAllOfFromJSONTyped,
    BookmarkedPressReleasesResponseAllOfToJSON,
} from './BookmarkedPressReleasesResponseAllOf';
import {
    BookmarkedPressReleasesResponseAllOfData,
    BookmarkedPressReleasesResponseAllOfDataFromJSON,
    BookmarkedPressReleasesResponseAllOfDataFromJSONTyped,
    BookmarkedPressReleasesResponseAllOfDataToJSON,
} from './BookmarkedPressReleasesResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 保存済みプレスリリース一覧を取得したときのレスポンス
 * @export
 * @interface BookmarkedPressReleasesResponse
 */
export interface BookmarkedPressReleasesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof BookmarkedPressReleasesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof BookmarkedPressReleasesResponse
     */
    message: string;
    /**
     * 
     * @type {BookmarkedPressReleasesResponseAllOfData}
     * @memberof BookmarkedPressReleasesResponse
     */
    data: BookmarkedPressReleasesResponseAllOfData;
}

export function BookmarkedPressReleasesResponseFromJSON(json: any): BookmarkedPressReleasesResponse {
    return BookmarkedPressReleasesResponseFromJSONTyped(json, false);
}

export function BookmarkedPressReleasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookmarkedPressReleasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': BookmarkedPressReleasesResponseAllOfDataFromJSON(json['data']),
    };
}

export function BookmarkedPressReleasesResponseToJSON(value?: BookmarkedPressReleasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': BookmarkedPressReleasesResponseAllOfDataToJSON(value.data),
    };
}

